const autoScrollSlideshow = document.querySelector('.auto-scroll__slideshow--body_wrapper');
let tickerSpeed = autoScrollSlideshow.getAttribute("data-slider-speed");
let flickity = null;
let isPaused = false;
let currentIndex = 0;

const update = () => {
  if (isPaused) return;
  if (flickity.slides) {
    flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
    flickity.selectedIndex = flickity.dragEndRestingSelect();
    flickity.updateSelectedSlide();
    currentIndex = flickity.selectedIndex;
    flickity.settle(flickity.x);
  }
  window.requestAnimationFrame(update);
};

const pause = () => {
  isPaused = true;
};

const play = () => {
  if (isPaused) {
    isPaused = false;
    window.requestAnimationFrame(update);
  }
};

let prevWindowWidth = window.innerWidth;

const resizeHandler = () => {
  const currentWindowWidth = window.innerWidth;

  if (currentWindowWidth !== prevWindowWidth) {
    prevWindowWidth = currentWindowWidth;

    const slideElements = flickity.getCellElements();
    const slideWidth = slideElements[currentIndex].getBoundingClientRect().width;
    flickity.x = currentIndex * slideWidth * -1;
    flickity.resize();
  }
};

flickity = new Flickity(autoScrollSlideshow, {
  autoPlay: false,
  prevNextButtons: false,
  pageDots: false,
  draggable: true,
  wrapAround: true,
  selectedAttraction: 0.015,
  friction: 0.25,
  cellAlign: 'left',
  groupCells: true,
  resize: false
});

currentIndex = flickity.selectedIndex;

autoScrollSlideshow.addEventListener('mouseenter', pause, false);
autoScrollSlideshow.addEventListener('focusin', pause, false);
autoScrollSlideshow.addEventListener('mouseleave', play, false);
autoScrollSlideshow.addEventListener('focusout', play, false);
window.addEventListener('resize', resizeHandler);

flickity.on('dragStart', () => {
  isPaused = true;
});

document.addEventListener("DOMContentLoaded", function () {
  update();
  play();
})